if (!customElements.get('product-card-quantity-buy')) {
  customElements.define(
    'product-card-quantity-buy',
    class ProductCardQuantityBuy extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.querySelector('[data-card-quantity-input]');
        this.quantityChoices = Array.from(this.querySelectorAll('[data-card-quantity-choice]'));

        this.handleClickBound ||= this.handleClick.bind(this);
        this.addEventListener('click', this.handleClickBound);

        const selectedChoice = this.quantityChoices.find(
          (choice) => choice.getAttribute('aria-pressed') === 'true' && !choice.disabled
        );
        const initialChoice = selectedChoice || this.quantityChoices.find((choice) => !choice.disabled);
        if (initialChoice) this.selectQuantity(initialChoice);
      }

      disconnectedCallback() {
        if (this.handleClickBound) this.removeEventListener('click', this.handleClickBound);
      }

      handleClick(event) {
        const choice = event.target.closest?.('[data-card-quantity-choice]');
        if (!choice || choice.disabled || !this.contains(choice)) return;
        this.selectQuantity(choice);
      }

      selectQuantity(choice) {
        const quantity = Number.parseInt(choice.dataset.cardQuantityChoice, 10);
        if (!Number.isFinite(quantity) || quantity < 1) return;

        this.quantityChoices.forEach((candidate) => {
          candidate.setAttribute('aria-pressed', candidate === choice ? 'true' : 'false');
        });
        if (this.quantityInput) this.quantityInput.value = String(quantity);
      }
    }
  );
}
